jQuery(document).ready(function ($) {
  // Akkordeon bei den Produkten
  function toggleAccordion(event) {
    event.preventDefault();
    var _this = this;
    var $target;
  
    // Überprüfe den Typ des Elements und wähle das entsprechende Ziel
    if ($(_this).data('type') === 'accordeon-trigger') {
      // Wenn der Trigger innerhalb eines 'accordeon-item-link' Divs liegt, wähle das vorherige Element des Containers
      $target = $(_this).closest('.accordeon-item-link').prev();
    } else {
      $target = $(_this).next(); // Verwende das nächste Element
    }
  
    $target.slideToggle();
    $(_this).toggleClass('is-open');
    if ($(_this).hasClass('is-open')) {
      //accordeonScrollTo($(_this));
    }
  
    // Drehe das SVG im Link
    $(_this).find('svg').toggleClass('rotated');
  }
  
  // Verwende die Funktion als Event-Handler
  $('[data-type="accordeon-title"]').click(toggleAccordion);
  $('[data-type="accordeon-trigger"]').click(toggleAccordion);
  
  var accordeonScrollTo = function (target) {
    var t = target;
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });

    $page.animate({
      scrollTop: t.offset().top - 40,
    }, 'slow', function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false;
  };
});
